import { render, staticRenderFns } from "./PartnerWithUsForm.vue?vue&type=template&id=08b9700b&scoped=true&"
import script from "./PartnerWithUsForm.vue?vue&type=script&lang=js&"
export * from "./PartnerWithUsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b9700b",
  null
  
)

export default component.exports